import React, { useState } from "react";
import {
  Layout,
  Input,
  Button,
  Card,
  Typography,
  Form,
  message,
  Select,
  Steps,
  Spin,
  Upload,
  Alert,
  Tooltip
} from "antd";

import { useQuery, useQueryClient, useMutation } from 'react-query'
import { utilities } from "../../utilities/utlities";
import "./styles.css";
import { InfoCircleOutlined, WarningFilled, InfoCircleFilled } from "@ant-design/icons";
import FirstStep from "./firstStep";
import SecondStep from "./secondStep";
import ThirdStep from "./thirdStep";
import FourthStep from "./fourthStep";
import FifthStep from "./FifthStep";
import { UserRegistrationUpdate } from "./api";
import { useNavigator } from "../../utilities/navigation";
import { useEffect } from "react";
import { stepsConfiguration } from "../../configurations/stepsConfiguration";
import { profileconfig } from "../../configurations/profileconfig";

export default function Profile() {
  const { Content } = Layout;
  const { Title, Text, Link } = Typography;
  const { Step } = Steps;
  const [companyDetails, setCompanyDetails] = useState({});
  const { Option } = Select;
  const [navigator] = useNavigator()
  const [loading, setLoading] = useState(false);
  const [currentPathname,setCurrentPathname] = useState('')
  const [currentStep, setCurrentSetUp] = React.useState(0);
  const [userdata, setUser] = useState()
  const loginUser = utilities.loggedUser();
  const [objectKeys, setobjectionKey] = useState([])
  const [stepsData, setStepsData] = useState([])
  const client = useQueryClient()
  const [objection, setObjection] = useState([])
  const [resize, setResize] = useState(document?.documentElement?.clientWidth)

  window.addEventListener("resize", () => {

    // alert(document?.documentElement?.clientWidth)
    setResize(document?.documentElement?.clientWidth)
  });


  const navigateStep = (number) => {
    setCurrentSetUp(number);
  };

  const ongetSuccess = (data) => {
    getUser(data.data)
  }
  const ongetError = (err) => {

  }
  const { isLoading, refetch } = useQuery(['userdata', loginUser], async () => {
    return await UserRegistrationUpdate.fetchUserData(loginUser?.jwtToken)
  }, {
    enabled: false,
    onSuccess: ongetSuccess,
    onError: ongetError,
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 60

  })
  const { isLoading: resubmitLoading, mutateAsync: resubmit } = useMutation(async (Target) => {
    const response = await UserRegistrationUpdate.resubmit({ data: Target, loginUser: loginUser, objection: objection, })
    return { ...response, loginUser: loginUser, type: Target }
  }, {
    enabled: false,
    onError: (error, variables, context) => {
    },
    onSuccess: (data, variables, context) => {
      if (data?.type == "resubmission") {
        setObjection([])
      }
      else {
        message.success("Information resubmited Successful", 3)
      }
    }
  }
  )

  const { isLoading: verificationLoading, refetch: verification } = useQuery('userverfication', async () => {
    const urlParams = new URLSearchParams(window.location.search);
    const loggedUser = JSON.parse(localStorage.getItem("loggedUser"));
    const myParam = urlParams.get("verifyToken");
    console.log(myParam)
    // debugger
    if (loggedUser != null) {
      if (loggedUser?.isVerified != true && myParam != null) {
        const response = await UserRegistrationUpdate.verifyUserData(myParam)
        return { ...response, loggedUser: loggedUser }
      }
    }
  }, {
    enabled: false,
    onError: (error, variables, context) => {
      message.error(error.message, 2);
      setTimeout(() => {
        navigator("/profile/edit");
      }, 3000);
    },
    onSuccess: (data, variables, context) => {
      if (data != null && data != undefined) {
        const loggedUser = JSON.parse(localStorage.getItem("loggedUser"));
        loggedUser.isVerified = true;
        localStorage.setItem("loggedUser", JSON.stringify(loggedUser));
        message.success("Verified Successfully", 2);
        setTimeout(() => {
          navigator("/profile/edit");
        }, 3000);
      }
    }
  }
  )

  const mutation = useMutation(async (Target) => {
    const response = await UserRegistrationUpdate.updateUserdata(Target)
    return { ...response, step: Target?.step, progress: Target?.progress, userdata: Target, loginUser: loginUser }
  },
    {
      onError: (error, variables, context) => {
        message.error(error.message, 3)
      },
      onSuccess: (data, variables, context) => {
        if (data?.loginUser?.profileCompleted == true) {
          resubmit('resubmission')
        }
        setCompanyDetails({})
        message.success("Update user info successfully", 3)
        refetch()
        setCurrentSetUp(data?.step)
        updateUser(data.data)
        if (data?.progress == 'COMPLETE') {
          navigator('/profile')
        }
      }
    }
  )
  const getUser = async (data) => {
    var tabsData = stepsConfiguration?.[data?.user?.type]?.fields

    const objectionKey = data?.company?.objections?.map(item => item?.key)
    if (loginUser?.type != 'admin') {
      Object.keys(profileconfig?.[data?.user?.type])?.map(item => {
        profileconfig?.[data?.user?.type]?.[item]?.fields?.map(fields => {
          if (objectionKey?.includes(fields?.label2)) {
            const currentElementIndex = tabsData.findIndex(tab => item == tab.number)
            var objectFilter = tabsData?.find(tab => item == tab.number)
            objectFilter = { ...objectFilter, warning: true }
            if (objectFilter.hasOwnProperty('warning')) {
              tabsData.splice(currentElementIndex, 1)
              tabsData.splice(currentElementIndex, 0, objectFilter)
            }
            else {
              tabsData.splice(currentElementIndex, 0, objectFilter)
            }
          }
        })


      })
      setobjectionKey(objectionKey)
    }
    setStepsData(tabsData)
    console.log(data)
    var userdata = {
      firstName: data?.user?.firstName,
      lastName: data?.user?.lastName,
      mobileNumber: data?.user?.[loginUser?.type].mobileNumber || data?.user?.[loginUser?.type].telephoneNumber,
      jobTitle: data?.user?.[loginUser?.type].jobTitle,
      department: data?.user?.[loginUser?.type].department,
      comapnyname: data?.company?.companyName,
      numberofEmployee: data?.company?.numberOfEmployees,
      companyWebsite: data?.company?.companyWebsite,
      compnayPhone: data?.company?.phoneNumber,
      country: data?.company?.location?.country,
      city: data?.company?.location?.city,
      street: data?.company?.location?.street,
      postalcode: data?.company?.location?.postCode,
      firstName_billing: data?.company?.billingPerson?.firstName,
      lastName_billing: data?.company?.billingPerson?.lastName,
      email_billing: data?.company?.billingPerson?.email,
      jobTitle_billing: data?.company?.billingPerson?.jobTitle,
      department_billing: data?.company?.billingPerson?.department,
      phone_billing: data?.company?.billingPerson?.mobileNumber,
      linkedIn_billing: data?.company?.billingPerson?.linkedInProfile,


      firstName_authorized: data?.company?.authorizedSignatory?.firstName || data?.company?.invoicePerson?.firstName,
      lastName_authorized: data?.company?.authorizedSignatory?.lastName || data?.company?.invoicePerson?.surname,
      email_authorized: data?.company?.authorizedSignatory?.email || data?.company?.invoicePerson?.email,
      jobTitle_authorized: data?.company?.authorizedSignatory?.jobTitle || data?.company?.invoicePerson?.jobTitle,
      departmant_authorized: data?.company?.authorizedSignatory?.department || data?.company?.invoicePerson?.department,
      phone_authorized: data?.company?.authorizedSignatory?.phone || data?.company?.invoicePerson?.telephoneNumber,
      linkedIn_authorized: data?.company?.authorizedSignatory?.linkedInProfile,
      invoicePersonCountry: data?.company?.invoicePerson?.country,
      personPostal: data?.company?.invoicePerson?.postCode,

      surname: data?.user?.[loginUser?.type].surname,
      title: data?.user?.[loginUser?.type].title,
      vatcountry: data?.company?.vatCountry,
      Vatnumber: data?.company?.vatNumber,
      registrationNumber: data?.company?.registrationNumber,
      gmpCertficate: {
        name: data?.company?.documents?.gmpCertficate?.split('-key-')[1],
        url: data?.company?.documents?.gmpCertficate
      },
      tradeLicense: {
        name:
          data?.company?.documents?.tradeLicense?.split('-key-')[1],
        url: data?.company?.documents?.tradeLicense
      },
      trnCertificate: {
        name:
          data?.company?.documents?.trnCertificate?.split('-key-')[1],
        url: data?.company?.documents?.trnCertificate
      },

      manufacturingLicense: {
        name: data?.company?.documents?.manufacturingLicense?.split('-key-')[1],
        url: data?.company?.documents?.manufacturingLicense
      },
      siteMasterFile: {
        name: data?.company?.documents?.siteMasterFile?.split('-key-')[1],
        url: data?.company?.documents?.siteMasterFile
      },
      detailedCompanyProfile: {
        name: data?.company?.documents?.detailedCompanyProfile?.split('-key-')[1],
        url: data?.company?.documents?.detailedCompanyProfile
      },
      listOfManufacturedMedicinces: {
        name: data?.company?.documents?.listOfManufacturedMedicinces?.split('-key-')[1],
        url: data?.company?.documents?.listOfManufacturedMedicinces
      },
      certificatesOfGoodManufacturingPractices: {
        name: data?.company?.documents?.certificatesOfGoodManufacturingPractices.length > 0 ? data?.company?.documents?.certificatesOfGoodManufacturingPractices[0].split('-key-')[1] : undefined,
        url: data?.company?.documents?.certificatesOfGoodManufacturingPractices.length > 0 ? data?.company?.documents?.certificatesOfGoodManufacturingPractices[0] : undefined
      },
      certificatesOfRegistration: {
        name: data?.company?.documents?.certificatesOfRegistration.length > 0 ? data?.company?.documents?.certificatesOfRegistration[0].split('-key-')[1] : undefined,
        url: data?.company?.documents?.certificatesOfRegistration.length > 0 ? data?.company?.documents?.certificatesOfRegistration[0] : undefined
      }

    }
    setUser(userdata)
  }


  React.useEffect(() => {
    if (loginUser == null) {
      navigator('/login')
    }
    else {
      if (loginUser?.isVerified == true) {
        navigateStep(1);
      }
      else {
        verification();
      }
      if (client.getQueryData('userdata') != undefined) {
        return client.getQueryData('userdata')?.data
      } else {
        refetch()
      }
    }
  }
    , []);

  const updateUser = (data) => {
      console.log(data)
    if (data != null) {
      var tabsData = stepsConfiguration?.[data?.user?.type]?.fields

      const objectionKey = data?.company?.objections?.map(item => item?.key)
      console.log(data?.company);
      console.log(objectionKey)
      if (loginUser?.type != 'admin') {
        Object.keys(profileconfig?.[data?.user?.type])?.map(item => {
          profileconfig?.[data?.user?.type]?.[item]?.fields?.map(fields => {
            if (objectKeys?.length != 0  && objectKeys != undefined){ 
            if(objectionKey?.includes(fields?.label2))
            {
              const currentElementIndex = tabsData.findIndex(tab => item == tab.number)
              var objectFilter = tabsData?.find(tab => item == tab.number)
              objectFilter = { ...objectFilter, warning: true }
              if (objectFilter.hasOwnProperty('warning')) {
                tabsData.splice(currentElementIndex, 1)
                tabsData.splice(currentElementIndex, 0, objectFilter)
              }
              else {
                tabsData.splice(currentElementIndex, 0, objectFilter)
              }
            }
            }
          })


        })
        setobjectionKey(objectionKey)
      }
      setStepsData(tabsData)
      var userdata = {
        firstName: data?.user?.firstName,
        lastName: data?.user?.lastName,
        mobileNumber: data?.user?.[data?.user?.type].mobileNumber || data?.user?.[data?.user?.type].telephoneNumber,
        jobTitle: data?.user?.[data?.user?.type].jobTitle,
        department: data?.user?.[data?.user?.type].department,
        comapnyname: data?.company?.companyName,
        numberofEmployee: data?.company?.numberOfEmployees,
        companyWebsite: data?.company?.companyWebsite,
        compnayPhone: data?.company?.phoneNumber,
        country: data?.company?.location?.country,
        city: data?.company?.location?.city,
        street: data?.company?.location?.street,
        postalcode: data?.company?.location?.postCode,
        firstName_billing: data?.company?.billingPerson?.firstName,
        lastName_billing: data?.company?.billingPerson?.lastName,
        email_billing: data?.company?.billingPerson?.email,
        jobTitle_billing: data?.company?.billingPerson?.jobTitle,
        department_billing: data?.company?.billingPerson?.department,
        phone_billing: data?.company?.billingPerson?.mobileNumber,
        linkedIn_billing: data?.company?.billingPerson?.linkedInProfile,
        invoicePersonCountry: data?.company?.invoicePerson?.country,
        personPostal: data?.company?.invoicePerson?.postCode,

        firstName_authorized: data?.company?.authorizedSignatory?.firstName || data?.company?.invoicePerson?.firstName,
        lastName_authorized: data?.company?.authorizedSignatory?.lastName || data?.company?.invoicePerson?.surname,
        email_authorized: data?.company?.authorizedSignatory?.email || data?.company?.invoicePerson?.email,
        jobTitle_authorized: data?.company?.authorizedSignatory?.jobTitle || data?.company?.invoicePerson?.jobTitle,
        departmant_authorized: data?.company?.authorizedSignatory?.department || data?.company?.invoicePerson?.department,
        phone_authorized: data?.company?.authorizedSignatory?.phone || data?.company?.invoicePerson?.telephoneNumber,
        linkedIn_authorized: data?.company?.authorizedSignatory?.linkedInProfile,


        surname: data?.user?.[data?.user?.type].surname,
        title: data?.user?.[data?.user?.type].title,
        vatcountry: data?.company?.vatCountry,
        Vatnumber: data?.company?.vatNumber,
        registrationNumber: data?.company?.registrationNumber,

        tradeLicense: {
          name:
            data?.company?.documents?.tradeLicense?.split('-key-')[1],
          url: data?.company?.documents?.tradeLicense
        },
        trnCertificate: {
          name:
            data?.company?.documents?.trnCertificate?.split('-key-')[1],
          url: data?.company?.documents?.trnCertificate
        },


        gmpCertficate: {
          name: data?.company?.documents?.gmpCertficate?.split('-key-')[1],
          url: data?.company?.documents?.gmpCertficate
        },

        manufacturingLicense: {
          name: data?.company?.documents?.manufacturingLicense?.split('-key-')[1],
          url: data?.company?.documents?.manufacturingLicense
        },
        siteMasterFile: {
          name: data?.company?.documents?.siteMasterFile?.split('-key-')[1],
          url: data?.company?.documents?.siteMasterFile
        },
        detailedCompanyProfile: {
          name: data?.company?.documents?.detailedCompanyProfile?.split('-key-')[1],
          url: data?.company?.documents?.detailedCompanyProfile
        },
        listOfManufacturedMedicinces: {
          name: data?.company?.documents?.listOfManufacturedMedicinces?.split('-key-')[1],
          url: data?.company?.documents?.listOfManufacturedMedicinces
        },
        certificatesOfGoodManufacturingPractices: {
          name: data?.company?.documents?.certificatesOfGoodManufacturingPractices.length > 0 ? data?.company?.documents?.certificatesOfGoodManufacturingPractices[0].split('-key-')[1] : undefined,
          url: data?.company?.documents?.certificatesOfGoodManufacturingPractices.length > 0 ? data?.company?.documents?.certificatesOfGoodManufacturingPractices[0] : undefined
        },
        certificatesOfRegistration: {
          name: data?.company?.documents?.certificatesOfRegistration.length > 0 ? data?.company?.documents?.certificatesOfRegistration[0].split('-key-')[1] : undefined,
          url: data?.company?.documents?.certificatesOfRegistration.length > 0 ? data?.company?.documents?.certificatesOfRegistration[0] : undefined
        }

      }
      setUser(userdata)
    }

  }
  const CompleteRegistration = (step, progress = '') => {
    const logged = utilities.loggedUser();
    if (logged != null) {
      
      if (logged.type == "distributor") {
        console.log(companyDetails)
        let data = {
          firstName: companyDetails?.firstName,
          lastName: companyDetails?.lastName,
          jobTitle: companyDetails?.jobTitle,
          department: companyDetails?.department,
          phoneNumber: companyDetails?.phoneNumber,
          companyDetails: {
            companyName: companyDetails?.companyName,
            location: {
              country: companyDetails?.country,
              street: companyDetails?.street,
              city: companyDetails?.city,
              postCode: companyDetails?.postCode,
            },
            companyWebsite: companyDetails?.companyWebsite,
            numberOfEmployees: companyDetails?.numberOfEmployees,
            phoneNumber: companyDetails?.compnayPhone,
            billingPerson: {
              firstName: companyDetails?.firstName_billing,
              lastName: companyDetails?.lastName_billing,
              email: companyDetails?.email_billing,
              jobTitle: companyDetails?.jobTitle_billing,
              linkedInProfile: companyDetails?.linkedIn_billing,
              department: companyDetails?.department_billing,
              mobileNumber: companyDetails?.phone_billing,
            },
            authorizedSignatory: {
              firstName: companyDetails?.firstName_authorized,
              lastName: companyDetails?.lastName_authorized,
              email: companyDetails?.email_authorized,
              jobTitle: companyDetails?.jobTitle_authorized,
              linkedInProfile: companyDetails?.linkedIn_authorized,
              department: companyDetails?.departmant_authorized,
              mobileNumber: companyDetails?.phone_authorized,
            },
          },
          resubmissions: loginUser?.profileCompleted == true ? objection : []
        };

       if (data?.companyDetails?.companyName == undefined) {
          delete data?.companyDetails?.companyName
        }
        if (data?.companyDetails?.companyWebsite == undefined) {
          delete data?.companyDetails?.companyWebsite
        }
        if (data?.companyDetails?.numberOfEmployees == undefined) {
          delete data?.companyDetails?.numberOfEmployees
        }
        if (data?.companyDetails?.phoneNumber == undefined) {
          delete data?.companyDetails?.phoneNumber
        }
        if (data?.companyDetails?.billingPerson?.email == undefined) {
          delete data?.companyDetails?.billingPerson?.email
        }
        if (data?.companyDetails?.billingPerson?.firstName == undefined) {
          delete data?.companyDetails?.billingPerson?.firstName
        }
        if (data?.companyDetails?.billingPerson?.lastName == undefined) {
          delete data?.companyDetails?.billingPerson?.lastName
        }
        if (data?.companyDetails?.billingPerson?.jobTitle == undefined) {
          delete data?.companyDetails?.billingPerson?.jobTitle
        }
        if (data?.companyDetails?.billingPerson?.mobileNumber == undefined) {
          delete data?.companyDetails?.billingPerson?.mobileNumber
        }
        if (data?.companyDetails?.billingPerson?.department == undefined) {
          delete data?.companyDetails?.billingPerson?.department
        }
        if (data?.companyDetails?.billingPerson?.linkedInProfile == undefined) {
          delete data?.companyDetails?.billingPerson?.linkedInProfile
        }
        if (data?.companyDetails?.location?.city == undefined) {
          delete data?.companyDetails?.location?.city
        }
        if (data?.companyDetails?.location?.country == undefined) {
          delete data?.companyDetails?.location?.country
        }
        if (data?.companyDetails?.location?.postCode == undefined) {
          delete data?.companyDetails?.location?.postCode
        }
        if (data?.companyDetails?.location?.street == undefined) {
          delete data?.companyDetails?.location?.street
        }
        if (data?.companyDetails?.authorizedSignatory?.linkedInProfile == undefined) {
          delete data?.companyDetails?.authorizedSignatory?.linkedInProfile
        }
        if (data?.companyDetails?.authorizedSignatory?.firstName == undefined) {
          delete data?.companyDetails?.authorizedSignatory?.firstName
        }
        if (data?.companyDetails?.authorizedSignatory?.lastName == undefined) {
          delete data?.companyDetails?.authorizedSignatory?.lastName
        }
        if (data?.companyDetails?.authorizedSignatory?.email == undefined) {
          delete data?.companyDetails?.authorizedSignatory?.email
        }
        if (data?.companyDetails?.authorizedSignatory?.jobTitle == undefined) {
          delete data?.companyDetails?.authorizedSignatory?.jobTitle
        }
        if (data?.companyDetails?.authorizedSignatory?.department == undefined) {
          delete data?.companyDetails?.authorizedSignatory?.department
        }
        if (data?.companyDetails?.authorizedSignatory?.mobileNumber == undefined) {
          delete data?.companyDetails?.authorizedSignatory?.mobileNumber
        }
        if(Object.keys(data?.companyDetails?.authorizedSignatory).length == 0){
          delete data?.companyDetails?.authorizedSignatory
        }

        if(Object.keys(data?.companyDetails?.billingPerson).length == 0){
          delete data?.companyDetails?.billingPerson
        }
        if(Object.keys(data?.companyDetails?.location).length == 0){
          delete data?.companyDetails?.location
        }
        if(Object.keys(data?.companyDetails).length == 0){
          delete data?.companyDetails
        }
        console.log(data)


        const loggedUser = JSON.parse(localStorage.getItem("loggedUser"));
        mutation.mutateAsync({
          step: step,
          data: data,
          token: loggedUser?.jwtToken,
          type: loggedUser?.type,
          progress: progress
        })
      } else {
        console.log(companyDetails)
        let data = {
          firstName: companyDetails?.firstName,
          lastName: companyDetails?.lastName,
          surname: companyDetails?.surname,
          jobTitle: companyDetails?.jobTitle,
          title: companyDetails?.title,
          telephoneNumber: companyDetails?.telephoneNumber,
          companyDetails: {
            companyName: companyDetails?.companyName,
            location: {
              country: companyDetails?.country,
              street: companyDetails?.street,
              city: companyDetails?.city,
              postCode: companyDetails?.postCode,
            },
            companyWebsite: companyDetails?.companyWebsite,
            vatCountry: companyDetails?.vatCountry,
            vatNumber: companyDetails?.vatNumber,
            registrationNumber: companyDetails?.registrationNumber,
            invoicePerson: {
              firstName: companyDetails?.firstName_authorized,
              surname: companyDetails?.lastName_authorized,
              email: companyDetails?.email_authorized,
              jobTitle: companyDetails?.jobTitle_authorized,
              telephoneNumber: companyDetails?.phone_authorized,
              postCode: companyDetails?.personPostal,
              country: companyDetails?.invoicePersonCountry,
            },
          },
          resubmissions: loginUser?.profileCompleted == true ? objection : []
        };
        console.log(data)
        if (data?.companyDetails?.companyName == undefined) {
          delete data?.companyDetails?.companyName
        }
        if (data?.companyDetails?.companyWebsite == undefined) {
          delete data?.companyDetails?.companyWebsite
        }
        if (data?.companyDetails?.registrationNumber == undefined) {
          delete data?.companyDetails?.registrationNumber
        }
        if (data?.companyDetails?.vatCountry == undefined) {
          delete data?.companyDetails?.vatCountry
        }
        if (data?.companyDetails?.vatNumber == undefined) {
          delete data?.companyDetails?.vatNumber
        }
        if (data?.companyDetails?.invoicePerson?.country == undefined) {
          delete data?.companyDetails?.invoicePerson?.country
        }
        if (data?.companyDetails?.invoicePerson?.email == undefined) {
          delete data?.companyDetails?.invoicePerson?.email
        }
        if (data?.companyDetails?.invoicePerson?.firstName == undefined) {
          delete data?.companyDetails?.invoicePerson?.firstName
        }
        if (data?.companyDetails?.invoicePerson?.jobTitle == undefined) {
          delete data?.companyDetails?.invoicePerson?.jobTitle
        }
        if (data?.companyDetails?.invoicePerson?.postCode == undefined) {
          delete data?.companyDetails?.invoicePerson?.postCode
        }
        if (data?.companyDetails?.invoicePerson?.surname == undefined) {
          delete data?.companyDetails?.invoicePerson?.surname
        }
        if (data?.companyDetails?.invoicePerson?.telephoneNumber == undefined) {
          delete data?.companyDetails?.invoicePerson?.telephoneNumber
        }
        if (data?.companyDetails?.location?.city == undefined) {
          delete data?.companyDetails?.location?.city
        }
        if (data?.companyDetails?.location?.country == undefined) {
          delete data?.companyDetails?.location?.country
        }
        if (data?.companyDetails?.location?.postCode == undefined) {
          delete data?.companyDetails?.location?.postCode
        }
        if (data?.companyDetails?.location?.street == undefined) {
          delete data?.companyDetails?.location?.street
        }
        if(Object.keys(data?.companyDetails?.invoicePerson).length == 0){
          delete data?.companyDetails?.invoicePerson
        }
        if(Object.keys(data?.companyDetails?.location).length == 0){
          delete data?.companyDetails?.location
        }
        if(Object.keys(data?.companyDetails).length == 0){
          delete data?.companyDetails
        }
        console.log(data)
        const loggedUser = JSON.parse(localStorage.getItem("loggedUser"));
        mutation.mutateAsync({
          step: step,
          data: data,
          token: loggedUser?.jwtToken,
          type: loggedUser?.type,
          progress: progress
        })
      }
    }
  };
  const updateCompanyDetails = (key, value, type, objectionKey) => {
    var objectionKeys = []
    objectionKeys.push(objectionKey)
    setObjection(objectionKeys)
    setCompanyDetails({
      ...companyDetails,
      [key]: value,
    });

    setUser({
      ...userdata,
      [type]: value

    })

    console.log(companyDetails)


  };
  const warningInfo = <div className="objectionWarning">
    <InfoCircleFilled />
    <Text>Please Make sure you <b>Submit Update</b>. Once you have done</Text>
    <Button
      className="submission"
      loading={resubmitLoading} size="large" type="primary" onClick={() => {
        if (loginUser?.profileCompleted == true) {
          resubmit('submission')
        }
      }}>
      Submit Updates
    </Button>
  </div>
  return (
    <Layout className="layout">
      <>
        <Content style={{ padding: loginUser?.type != 'admin' && isLoading == false && objectKeys?.length > 0 ? "0" : resize > 700 ? "0 50px" : "0 15px" }} className={`${isLoading == true ? 'loading-content' : ''}`}>
          {loginUser?.type != 'admin' && isLoading == false && objectKeys?.length > 0 ? <Alert message={warningInfo} type="warning"
            className="objectionWarning" /> : null}
          {isLoading == true ?
            <Spin size="large" tip="Please Wait..." />
            :
            <div className="site-layout-content">
              <div className="profileContentContainer">
                <div className="Formcontainer">
                  {currentStep == 0 ? <FirstStep loading={mutation.isLoading} /> : null}

                  {currentStep == 1 ? (
                    <SecondStep
                      navigateStep={navigateStep}
                      loading={mutation.isLoading}
                      updateCompanyDetails={updateCompanyDetails}
                      CompleteRegistration={CompleteRegistration}
                      userdata={userdata}
                      companyDetails={companyDetails}
                      objectKeys={objectKeys}
                      loginUser={loginUser}
                    />
                  ) : null}
                  {currentStep == 2 ? (
                    <ThirdStep
                      navigateStep={navigateStep}
                      updateCompanyDetails={updateCompanyDetails}
                      CompleteRegistration={CompleteRegistration}
                      companyDetails={companyDetails}
                      loading={mutation.isLoading}
                      userdata={userdata}
                      updateUser={updateUser}
                      objectKeys={objectKeys
                      }
                      loginUser={loginUser}
                    />
                  ) : null}
                  {
                    loginUser?.type == "distributor" ?
                      currentStep == 3 ? (
                        <FourthStep
                          navigateStep={navigateStep}
                          updateCompanyDetails={updateCompanyDetails}
                          CompleteRegistration={CompleteRegistration}
                          companyDetails={companyDetails}
                          loading={mutation.isLoading}
                          userdata={userdata}
                          objectKeys={objectKeys}
                          loginUser={loginUser}
                        />
                      ) : null :
                      currentStep == 3 ? (
                        <FifthStep
                          navigateStep={navigateStep}
                          updateCompanyDetails={updateCompanyDetails}
                          CompleteRegistration={CompleteRegistration}
                          companyDetails={companyDetails}
                          loading={mutation.isLoading}
                          userdata={userdata}
                          objectKeys={objectKeys}
                          loginUser={loginUser}
                        />
                      ) : null


                  }
                  {

                    currentStep == 4 ? (
                      <FifthStep
                        updateCompanyDetails={updateCompanyDetails}
                        CompleteRegistration={CompleteRegistration}
                        loading={loading}
                        userdata={userdata}
                        companyDetails={companyDetails}
                        loginUser={loginUser}
                      />
                    ) : null}
                </div>
                {loginUser?.isVerified == true ?
                  <Steps
                    onChange={(currentStep) => {
                      setCurrentSetUp(currentStep);
                    }}
                    current={currentStep}
                    direction="vertical"
                    className="stepper fullscreen"
                  >
                    {
                      stepsData?.map(item => {
                        if (item?.warning == true) {
                          return <Step title={item?.label} className="steptitle"
                            icon={
                              <Tooltip placement="top" title="Your profile have some objection by admin">
                            <WarningFilled className="IconClass" /></Tooltip>} />
                        } else {
                          return <Step title={item?.label} className="steptitle" />
                        }
                      })
                    }
                  </Steps>
                  :
                  <Steps
                    current={currentStep}
                    direction="vertical"
                    className="stepper fullscreen"
                  >
                    {
                      stepsData?.map(item => {
                        if (item?.warning == true) {
                          return <Step title={item?.label} className="steptitle"
                            icon={
                              <Tooltip placement="top" title="Your profile have some objection by admin">
                            <WarningFilled className="IconClass" /></Tooltip>} />
                        } else {
                          return <Step title={item?.label} className="steptitle" />
                        }
                      })
                    }
                  </Steps>
                }
                {loginUser?.isVerified == true ?
                  <Steps
                    onChange={(currentStep) => {
                      setCurrentSetUp(currentStep);
                    }}
                    current={currentStep}
                    direction='horizontal'
                    size="small"
                    className="mobileScreen"
                  >
                    {
                      stepsData?.map(item => {
                        if (item?.warning == true) {
                          return <Step title={item?.label} className="steptitle"
                            icon={
                              <Tooltip placement="top" title="Your profile have some objection by admin">
                            <WarningFilled className="IconClass" /></Tooltip>}/>
                        } else {
                          return <Step title={item?.label} className="steptitle" />
                        }
                      })
                    }
                  </Steps>
                  :
                  <Steps
                    current={currentStep}
                    // direction="vertical"
                    direction='horizontal'
                    size="small"
                    className="mobileScreen"
                  >
                    {
                      stepsData?.map(item => {
                        if (item?.warning == true) {
                          return <Step title={item?.label} className="steptitle"
                            icon={
                              <Tooltip placement="top" title="Your profile have some objection by admin">
                            <WarningFilled className="IconClass" /></Tooltip>} />
                        } else {
                          return <Step title={item?.label} className="steptitle" />
                        }
                      })
                    }
                  </Steps>
                }
              </div>
            </div>
          }

        </Content>
      </>
    </Layout>
  );
}
